import {useLocation, useParams} from "react-router";

import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {useMapTestQuery} from "../list/hooks/use_map_test_query";
import {IOfferListingParams} from "../types/OfferListingParams";

export function useOffersListUrl() {
    const {search} = useLocation();

    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useParams<IOfferListingParams>();

    const parsedSearch = parseSearch(search);
    const {_page, _sort, ...restSearch} = parsedSearch;

    const validSearch = useMapTestQuery(restSearch);

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        return appendQueryString(
            rpAppLink.offer.listFriendlyAbroad({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);

        const query = {
            ...validSearch,
            ...subFilterQuery
        };

        return appendQueryString(rpAppLink.offer.listFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendQueryString(
            rpAppLink.offer.listFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendQueryString(rpAppLink.offer.listFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiList(), validSearch);
}
import {useLocation, useParams} from "react-router";

import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {useMapTestQuery} from "../list/hooks/use_map_test_query";
import {IOfferListingParams} from "../types/OfferListingParams";

export function useOffersListUrl() {
    const {search} = useLocation();

    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useParams<IOfferListingParams>();

    const parsedSearch = parseSearch(search);
    const {_page, _sort, ...restSearch} = parsedSearch;

    const validSearch = useMapTestQuery(restSearch);

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        return appendQueryString(
            rpAppLink.offer.listFriendlyAbroad({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);

        const query = {
            ...validSearch,
            ...subFilterQuery
        };

        return appendQueryString(rpAppLink.offer.listFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendQueryString(
            rpAppLink.offer.listFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendQueryString(rpAppLink.offer.listFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiList(), validSearch);
}
